import Paper from "@mui/material/Paper";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { globalStyles } from "shared/constants";
import style from './style';

const GridView = ({
  data = [],
}) => {

  const columnConfig = [
    {
      label: 'NAME',
      field: 'name'
    },
    {
      label: 'SITE NAME',
      field: 'site_name',
      render: row => <TableCell>{row.site.name}</TableCell>
    },
    {
      label: 'STREET',
      field: 'street',
      render: row => <TableCell>{row.address.street}</TableCell>
    },
    {
      label: 'STREET 2 (APT./UNT.)',
      field: 'street2',
      render: row => <TableCell>{row.address.street2}</TableCell>
    },
    {
      label: 'CITY',
      field: 'city',
      render: row => <TableCell>{row.address.city}</TableCell>
    },
    {
      label: 'STATE',
      field: 'state',
      render: row => <TableCell>{row.address.state}</TableCell>
    },
    {
      label: 'ZIP',
      field: 'zip',
      render: row => <TableCell>{row.address.zip}</TableCell>
    },
    {
      label: 'Country',
      field: 'country',
      render: row => <TableCell>{row.address.country}</TableCell>
    },
  ]

  return (
    <Paper elevation={0}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ ...style.tableHead }}>
            <TableRow>
              {columnConfig.map(({ label }) => (
                <TableCell sx={{ ...globalStyles.text.color.white }}>{label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow key={row.name}>
                {columnConfig.map(config => (
                  config.render ? config.render(row) : <TableCell>{row[config.field]}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default GridView;
